import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
  data: null,
  loading: false,
  error: null,
  count: null,
  singleField: null,
};

export const getFieldMarketingList = createAsyncThunk(
  "getFieldMarketingList",
  async (body) => {
    try {
      const response = await instance.get(
        `/crm/fieldMarketing/fieldMarketing-list?page=${body.page}&search=${body.search}&fromDate=${body.fromDate}&toDate=${body.toDate}&lead_gen_by=${body.lead_gen_by}&sort_order=${body.sort_order} `
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

);


// ---------------------------------------------------------get all lat long data start 
export const getAlllatlongdata = createAsyncThunk(
  "getAlllatlongdata",
  async () => {
    try {
      const response = await instance.get(
        `/crm/location/get-all-planned-destination`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
// ---------------------------------------------------------get all lat long data end 


export const CreateFieldMarketing = createAsyncThunk(
  "CreateFieldMarketing",
  async (body) => {
    const formData = new FormData();
    formData.append("fm_name", body.fm_name);
    formData.append("fm_email", body.fm_email);
    formData.append("fm_phone", body.fm_phone);
    formData.append("fm_address", body.fm_address);
    formData.append("fm_designation", body.fm_designation);
    formData.append("fm_decision_maker", body.fm_decision_maker);
    formData.append("fm_purpose", body.fm_purpose);
    formData.append("fm_outcome", body.fm_outcome);
    formData.append("fm_needs", body.fm_needs);
    formData.append("fm_no_of_emp", body.fm_no_of_emp);
    formData.append("fm_company_name", body.fm_company_name);
    formData.append("fm_created_at", body.fm_created_at);
    formData.append("fm_description", body.fm_description);
    formData.append("fm_agenda", body.fm_agenda);

    formData.append("fm_subscription_buy", body.fm_subscription_buy);
    formData.append("fm_images", body.fm_images[0]);
    try {
      const response = await instance.post("/crm/fieldMarketing/create-fieldMarketing", formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export const UpdateFieldMarketing = createAsyncThunk(
  "UpdateFieldMarketing",
  async (body) => {
    const formData = new FormData();
    formData.append("fm_name", body.fm_name);
    formData.append("fm_email", body.fm_email);
    formData.append("fm_phone", body.fm_phone);
    formData.append("fm_address", body.fm_address);
    formData.append("fm_designation", body.fm_designation);
    formData.append("fm_decision_maker", body.fm_decision_maker);
    formData.append("fm_purpose", body.fm_purpose);
    formData.append("fm_outcome", body.fm_outcome);
    formData.append("fm_needs", body.fm_needs);
    formData.append("fm_no_of_emp", body.fm_no_of_emp);
    formData.append("fm_company_name", body.fm_company_name);
    formData.append("fm_subscription_buy", body.fm_subscription_buy);
    formData.append("fm_description", body.fm_description);
    formData.append("fm_agenda", body.fm_agenda);
    try {
      const res = await instance.post(
        `/crm/fieldMarketing/update-fieldMarketing?id=${body?.fm_id}`,
        formData
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
);

export const FieldMarketingSlice = createSlice({
  name: "FieldMarketingSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFieldMarketingList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getFieldMarketingList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.count = action.payload?.count;
    });
    builder.addCase(getFieldMarketingList.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(CreateFieldMarketing.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(CreateFieldMarketing.fulfilled, (state, action) => {
      state.loading = false;
      state.singleField = action.payload;
      state.count = action.payload?.count;
    });
    builder.addCase(CreateFieldMarketing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(UpdateFieldMarketing.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(UpdateFieldMarketing.fulfilled, (state, action) => {
      state.loading = false;
      state.singleField = action.payload;
      state.count = action.payload?.count;
    });
    builder.addCase(UpdateFieldMarketing.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default FieldMarketingSlice.reducer;
